var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6827 8.93622C14.278 8.93622 13.951 9.26407 13.951 9.66789V15.5216C13.951 15.9247 13.6232 16.2533 13.2193 16.2533H2.9754C2.57145 16.2533 2.24373 15.9247 2.24373 15.5216V5.27764C2.24373 4.8745 2.57145 4.54598 2.9754 4.54598H8.8291C9.23372 4.54598 9.56076 4.21813 9.56076 3.81432C9.56076 3.41037 9.23372 3.08252 8.8291 3.08252H2.9754C1.76516 3.08252 0.780273 4.0674 0.780273 5.27764V15.5216C0.780273 16.7318 1.76516 17.7167 2.9754 17.7167H13.2193C14.4296 17.7167 15.4145 16.7318 15.4145 15.5216V9.66789C15.4145 9.26327 15.0873 8.93622 14.6827 8.93622Z",
    fill: "#B92E81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64026 8.26973C7.58908 8.32091 7.55465 8.38602 7.54004 8.45623L7.02275 11.0436C6.99863 11.1636 7.03668 11.2872 7.12296 11.3743C7.1925 11.4438 7.28615 11.4811 7.38208 11.4811C7.40539 11.4811 7.42964 11.4789 7.45376 11.4739L10.0404 10.9566C10.112 10.9418 10.1772 10.9075 10.2277 10.8562L16.0169 5.06695L13.4303 2.48047L7.64026 8.26973Z",
    fill: "#B92E81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8053 0.691331C17.092 -0.0221104 15.9314 -0.0221104 15.2187 0.691331L14.2061 1.70395L16.7927 4.29056L17.8053 3.27781C18.1507 2.93321 18.3409 2.47366 18.3409 1.9849C18.3409 1.49615 18.1507 1.0366 17.8053 0.691331Z",
    fill: "#B92E81"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.561,
    height: 17.561,
    fill: "white",
    transform: "translate(0.780273 0.121948)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.dfb67351770a8148a378ae3257f419a5.svg";
export { ForwardRef as ReactComponent };